import { AcquisitionModeInFlightplan } from "../../models/AcquisitionMode"
import { FlightPlannedLineType, FlightplanType } from "../../store/types/FlightPlansTypes"
import { ValidatorModel } from "../../validation"

export const flightplanDisplayNames = {
    flight_plan_name: "Flightplan Name",
    status: "Flightplan Status",
    flightPlannedLines: "Flight Planned Lines",
    sensorConfigs: "Sensor Configurations",
    acquisition_platform: "Acquisition Platform",
}

export const getFlightplanValidatorModel = (
    flightplan: FlightplanType,
    flightPlannedLines: FlightPlannedLineType[],
    selectedModes: AcquisitionModeInFlightplan[],
): ValidatorModel => {
    const [plannedLinesError, displayMessage] = flightPlannedDuplicateValidation(
        flightPlannedLines.map((line) => line.flight_line_name),
    )

    let sensorConfigError: string | undefined
    selectedModes.forEach((mode) => {
        if (sensorConfigError == null) {
            if (mode.sensor_configurations.length === 0) {
                // Technically not possible, but may as well check
                sensorConfigError = "Ensure all acquisition modes have at least one sensor configuration."
            }
            mode.sensor_configurations.forEach((config) => {
                if (config.name.trim().length === 0) {
                    sensorConfigError = "No name set for sensor configuration"
                }
            })
        }
    })

    return {
        model: { ...flightplan, flightPlannedLines },
        display_names: flightplanDisplayNames,
        required_fields: ["flight_plan_name", "status", "acquisition_platform"],
        unique_fields: [
            {
                name: "flightPlannedLines",
                isError: plannedLinesError,
                text: displayMessage,
            },
            {
                name: "sensorConfigs",
                isError: sensorConfigError != null,
                text: sensorConfigError,
            },
        ],
        custom_validation_fields: [],
    }
}

const flightPlannedDuplicateValidation = (lineNames: string[]): [boolean, string] => {
    const uniqueNames = new Set(lineNames)

    const isError = uniqueNames.size < lineNames.length
    let displayMessage = "Cannot have duplicate line IDs"

    if (isError) {
        const duplicates =
            lineNames?.filter((line, index) => {
                return lineNames.indexOf(line) !== index
            }) ?? []
        const firstThreeDuplicates = duplicates.slice(0, 3)
        displayMessage = `${displayMessage}: ${firstThreeDuplicates.join(", ")} ${duplicates.length > 3 ? "..." : ""}`
    }

    return [isError, displayMessage]
}
